/** Maximum commission amount (pickup and seat delivery) a client or concession may configure. */
export const APP_ORDER_FEE_MAX: number = 999999;

/** Example-value placeholder for monetary commission inputs, distinct from their labels. */
export const APP_SERVICE_FEE_PLACEHOLDER: string = "0.00";

/** How a commission is charged, as stored: a flat amount or a percentage of the subtotal. */
export enum AppServiceFeeType {
  Fixed = 1,
  Percentage = 2,
}
